import { render, staticRenderFns } from "./VuetableColGroup.vue?vue&type=template&id=4ac37cdc&"
import script from "./VuetableColGroup.vue?vue&type=script&lang=js&"
export * from "./VuetableColGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports